import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overviewlifting',
  templateUrl: './overviewlifting.component.html',
  styleUrls: ['./overviewlifting.component.css']
})
export class OverviewliftingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
